import React, { useState } from 'react';
import { Card, Button, Row, Col, Image } from 'react-bootstrap';
import { GoTriangleDown, GoTriangleRight } from "react-icons/go";
import '../assets/styles/LongCard.css';

/* Long card to display an icon on the left,
title and description in the middle and a button on the right.
Used in the About Us pages */

const LongCard = ({ longcard }) => {
  const [expanded, setExpanded] = useState(false);

  const toggleExpand = () => {
    setExpanded(!expanded);
  };

  return (
    // border 0 to remove the borders of the card
    <Card className="h-100 p-0 border-0">
      <Card.Body className='p-2'>
        <Row className="align-items-center">
          {/* Column for the icon */}
          <Col xs="auto" className="d-flex justify-content-center">
            <div className="longcard-icon">
              <Image
              className="icon"
              style={{ padding: '5px', border : '1px solid #0000ff '}}
              src={longcard.icon} alt="icon" rounded />
            </div>
          </Col>

          {/* Column for title and description */}
          <Col className="pl-3">
            <Card.Title className="mb-1 font-weight-bold" onClick={toggleExpand} style={{color : "#7300ff", cursor: "pointer"}}>
              {longcard.title}
            </Card.Title>
            <Card.Text className="mb-0 longcard-description">
              {longcard.description}
            </Card.Text>
          </Col>

          {/* Column for the button */}
          <Col xs="auto" className="d-flex justify-content-end">
            <Button
              variant="link"
              onClick={toggleExpand}
              aria-expanded={expanded}
              aria-label={`Toggle details for ${longcard.title}`}
              style={{
                color: '#ffffff',
                backgroundColor: '#0000ff',
                padding: '0',
                width: '20px',
                height: '20px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              {expanded ? <GoTriangleDown /> : <GoTriangleRight />}
            </Button>
          </Col>
        </Row>

        {/* Added content when "expanded" is true */}
        {expanded && (
          <Row className="align-items-center mt-3">
            {/* For the details text aligned with description */}
            <Col style={{paddingLeft: '105px'}}>
              <Card.Text>{longcard.details}</Card.Text>
            </Col>
        </Row>
        )}
      </Card.Body>
    </Card>
  );
};

export default LongCard;
